import dateFns from 'date-fns'

import AppComponent from '../../mixins/app-component'

export default
{
    name: 'app-countdown',

    mixins: [
        AppComponent
    ],

    data() {
        return {
            formatedDateDeadline: '',
            dateNow: 0,
            deadline: 0,
            started: false,
            finished: false,
            countdown: {
                daysString: '00',
                daysSplitted: ['0', '0'],
                days: 0,
                hoursString: '00',
                hoursSplitted: ['0', '0'],
                hours: 0,
                minutesString: '00',
                minutesSplitted: ['0', '0'],
                minutes: 0,
                secondsString: '00',
                secondsSplitted: ['0', '0'],
                seconds: 0,
                milliseconds: 0
            }
        }
    },

    props: {
        dateDeadline: { type: null, default: null },
        use0Before: { type: Boolean, default: true }
    },

    created() {
        this.deadline = new Date(this.dateDeadline).getTime()
        this.formatedDateDeadline = dateFns.format(this.deadline, 'dddd Do[,] MMMM YYYY [at] HH[:]mm[:]ss')
    },

    methods:
    {
        onFrame() {
            // Update on each frame the countdown
            this._updateCountdown()
        },

        _updateCountdown() {
            if (this.countdown.milliseconds <= 0 && this.countdown.seconds === 0 && this.countdown.minutes === 0 && this.countdown.hours === 0 && this.countdown.days === 0 && this.started && !this.finished) {
                this.finished = true
            } else {
                if (!this.started) this.started = true

                // Get the new dateNow
                this.dateNow = new Date().getTime()

                // Get the difference in milliseconds between the deadline and dateNow
                this.countdown.milliseconds = this._getMilliseconds()

                if (this.countdown.milliseconds > 0) {
                    // If it's in future
                    if (this.countdown.seconds !== this._getSeconds()) {
                        // If it's a new seconds
                        this.countdown.seconds = this._getSeconds()
                        this.countdown.minutes = this._getMinutes()
                        this.countdown.hours = this._getHours()
                        this.countdown.days = this._getDays()

                        if (this.use0Before) {
                            // If we want a format like '05 seconds' instead of '5 seconds'
                            this.countdown.secondsString = this.countdown.seconds < 10 ? `0${this.countdown.seconds}` : String(this.countdown.seconds)
                            this.countdown.minutesString = this.countdown.minutes < 10 ? `0${this.countdown.minutes}` : String(this.countdown.minutes)
                            this.countdown.hoursString = this.countdown.hours < 10 ? `0${this.countdown.hours}` : String(this.countdown.hours)
                            this.countdown.daysString = this.countdown.days < 10 ? `0${this.countdown.days}` : String(this.countdown.days)
                        } else {
                            this.countdown.secondsString = String(this.countdown.seconds)
                            this.countdown.minutesString = String(this.countdown.minutes)
                            this.countdown.hoursString = String(this.countdown.hours)
                            this.countdown.daysString = String(this.countdown.days)
                        }

                        this.countdown.daysSplitted = this.countdown.daysString.split('')
                        this.countdown.hoursSplitted = this.countdown.hoursString.split('')
                        this.countdown.minutesSplitted = this.countdown.minutesString.split('')
                        this.countdown.secondsSplitted = this.countdown.secondsString.split('')

                        this.eventHub.$emit('app-countdown:update', this.countdown)
                    }
                }
            }
        },

        _getMilliseconds() {
            return this.deadline - this.dateNow
        },

        _getSeconds() {
            return Math.floor((this.countdown.milliseconds % (1000 * 60)) / 1000)
        },

        _getMinutes() {
            return Math.floor((this.countdown.milliseconds % (1000 * 60 * 60)) / (1000 * 60))
        },

        _getHours() {
            return Math.floor((this.countdown.milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        },

        _getDays() {
            return Math.floor(this.countdown.milliseconds / (1000 * 60 * 60 * 24))
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-countdown/script.js